import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import '../general/General.css';
import { useNavigate } from "react-router-dom";
import { useCheckAccess } from "../../utils/Utilities";
import CategoryStatement from "../money/CategoryStatement";

const DonationAdmin = () => {
  useCheckAccess('DonationRO'); // Check if the user is logged in (if no user data, redirect to login)
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Donation Admin</title>
        <link rel="canonical" href="/donation" />
      </Helmet>
      <>
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <button onClick={() => navigate("/donation/create")}>புதிய நன்கொடை சேகரிப்பு</button>
              <br />
            </div>
          </div>
        </div>

        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <CategoryStatement />
            </div>
          </div>
        </div>
      </>
      <br />
      <Footer />
    </>
  );
};

export default DonationAdmin;
